import React, { useEffect, useMemo, useState } from 'react';
import { CatalogAPI } from '../lib/api';
import { useSiteConfig } from '../context/SiteConfigContext';

const BrandsCarousel = () => {
  const [brands, setBrands] = useState([]);
  const { config } = useSiteConfig();
  const customOrder = Array.isArray(config['home.brands_order']) ? config['home.brands_order'] : [];

  useEffect(() => { CatalogAPI.brands().then(setBrands).catch(() => {}); }, []);

  // Ordonne : d'abord les marques choisies par l'admin (dans cet ordre), puis le reste
  const ordered = useMemo(() => {
    if (!customOrder.length) return brands;
    const set = new Set(brands);
    const head = customOrder.filter(b => set.has(b));
    const headSet = new Set(head);
    const tail = brands.filter(b => !headSet.has(b));
    return [...head, ...tail];
  }, [brands, customOrder]);

  return (
    <section className="bg-white border-y border-[#E8E0D0] py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">Nos meilleures marques</h2>
          <p className="text-[#7A6F5C] mt-2">Plus de 200 marques internationales et locales</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {ordered.map((b) => (
            <div key={b} className="card-hover bg-[#FAF7F2] border border-[#E8E0D0] rounded-lg h-20 flex items-center justify-center px-4">
              <span className="font-serif text-lg text-[#1F4D3F] font-medium text-center">{b}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <div className="inline-block text-sm text-[#7A6F5C] mb-3">Simple. Intelligent. Partenaire.</div>
          <div>
            <a href="/inscription?role=supplier" className="inline-flex items-center gap-2 bg-[#1F4D3F] hover:bg-[#173B30] text-white px-6 py-3 rounded-lg font-medium">
              Devenir partenaire fournisseur
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;
